import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestFormPopupComponent } from './request-form-popup.component';
import { MaterialModule } from 'src/app/shared/material/material.module';

@NgModule({
  declarations: [RequestFormPopupComponent],
  imports: [CommonModule, MaterialModule],
  exports: [RequestFormPopupComponent],
})
export class RequestFormPopupModule {}
